export { default } from './Content';



// WEBPACK FOOTER //
// ./src/lauoyts/LayoutApp/Content/index.js